import { format, formatDistanceToNowStrict, isToday, isTomorrow } from "date-fns";

export const SERVICES = {
  CUSTOM_SOFTWARE: "Custom Software",
  MOBILE_APP: "Mobile App",
  WEB_APP: "Web App",
  DIGITAL_MARKETING: "Digital Marketing",
  CLOUD_MANAGED: "Cloud & Managed IT",
  TELECOM_HVAC_IT: "Telecom / HVAC IT",
};

export const STAGES = ["AWARENESS", "ENGAGEMENT", "DISCOVERY", "PROPOSAL", "WON", "LOST"];
export const STAGE_LABELS = {
  AWARENESS: "Awareness", ENGAGEMENT: "Engagement", DISCOVERY: "Discovery & Eval",
  PROPOSAL: "Proposal & Decision", WON: "Won / Activated", LOST: "Disqualified",
};
export const STAGE_STYLE = {
  AWARENESS: "text-neutral-700 border-neutral-300 bg-neutral-100",
  ENGAGEMENT: "text-[#137A5E] border-[#BFE6D8] bg-[#E6F5EF]",
  DISCOVERY: "text-[#7A6A00] border-[#EADC6E] bg-[#FBF5C9]",
  PROPOSAL: "text-[#A85E00] border-[#F6C47A] bg-[#FFF0D9]",
  WON: "text-white border-[#1F9E7A] bg-[#1F9E7A]",
  LOST: "text-rose-700 border-rose-200 bg-rose-50",
};

export const STATUSES = ["CONTACT_PENDING", "CALL_ATTEMPTED", "CONNECTED", "REQUIREMENT_CALL_SCHEDULED", "SCOPING_IN_PROGRESS",
  "QUOTE_REVIEW_PENDING", "PROPOSAL_SENT", "NEGOTIATION", "RE_ENGAGEMENT", "NURTURING", "CLOSED"];
export const label = (s) => (s || "").replace(/_/g, " ").toLowerCase().replace(/(^|\s)\S/g, (c) => c.toUpperCase());

export const MEETING_STYLE = {
  SCHEDULED: "border-[#BFE6D8] text-[#137A5E] bg-[#E6F5EF]",
  IN_PROGRESS: "border-[#1F9E7A] text-white bg-[#1F9E7A] animate-pulse",
  PENDING_DISPOSITION: "border-rose-300 text-rose-700 bg-rose-50 font-semibold",
  COMPLETED: "border-[#1F9E7A] text-white bg-[#1F9E7A]",
  NO_SHOW: "border-[#F6C47A] text-[#A85E00] bg-[#FFF0D9]",
  RESCHEDULED: "border-[#EADC6E] text-[#7A6A00] bg-[#FBF5C9]",
  CANCELLED: "border-neutral-300 text-neutral-500 bg-neutral-100",
};

export const MEETING_TYPES = ["DISCOVERY", "TECH_DEMO", "REQUIREMENT_SCOPING", "PROPOSAL_REVIEW"];
export const OUTCOMES = ["QUALIFIED_SCOPE", "PROPOSAL_REQUESTED", "NEEDS_FOLLOW_UP", "REJECTED"];
export const LOSS_REASONS = ["Budget Mismatch", "Scope Misalignment", "Non-Responsive", "Chose Competitor", "Timeline Mismatch"];
export const ROLE_LABELS = { ADMIN: "Administrator", SALES_MANAGER: "Sales Manager", SALES_EXEC: "Sales Executive", CLINIC_STAFF: "Clinic Staff" };

export const fmtDT = (iso) => (iso ? format(new Date(iso), "dd MMM, h:mm a") : "—");
export const fmtTime = (iso) => {
  if (!iso) return "No action set";
  const d = new Date(iso);
  if (isToday(d)) return `Today ${format(d, "h:mm a")}`;
  if (isTomorrow(d)) return `Tomorrow ${format(d, "h:mm a")}`;
  return format(d, "dd MMM, h:mm a");
};
export const ago = (iso) => (iso ? formatDistanceToNowStrict(new Date(iso), { addSuffix: true }) : "");
export const inr = (v) =>
  v == null ? "—" : new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(v);
export const inrShort = (v) => {
  if (!v) return "₹0";
  if (v >= 1e7) return `₹${(v / 1e7).toFixed(2)}Cr`;
  if (v >= 1e5) return `₹${(v / 1e5).toFixed(1)}L`;
  if (v >= 1e3) return `₹${(v / 1e3).toFixed(0)}K`;
  return `₹${v}`;
};
export const waLink = (phone, text = "") =>
  `https://wa.me/${(phone || "").replace(/\D/g, "")}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const presetAt = (kind) => {
  const d = new Date();
  if (kind === "2h") return new Date(Date.now() + 2 * 3600e3);
  const days = { tomorrow: 1, "3d": 3, week: 7 }[kind] || 1;
  d.setDate(d.getDate() + days);
  d.setHours(10, 0, 0, 0);
  return d;
};
export const toLocalInput = (d) => {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
};
